import * as React from "react";
import { connect } from "react-redux";
import NapeosFileBrowser from "../components/FileBrowser/NapeosFileBrowser";
import { FileBrowserNapeosContext } from "../contexts";
import { withContext } from "../contexts/withContext";
import { Dialog } from "../components/externals";
const _FileBrowserNapeosFileManager = (props) => {
    let elements = typeof props.elements === "undefined" ||
        Object.keys(props.elements).length == 0
        ? { collection: { items: [] } }
        : props.elements;
    const extensions = [];
    for (let i = 0; i < elements.collection.items.length; i++) {
        const elemName = elements.collection.items[i].name;
        if (elemName !== "..") {
            const pos = elemName.lastIndexOf(".");
            if (pos !== -1) {
                extensions.push(elemName.substring(pos + 1));
            }
        }
    }
    return (React.createElement(Dialog, { className: "filebrowser-dialog", icon: "folder-open", title: "File Browser", isOpen: props.isDialogOpen, onClose: props.onCancel },
        React.createElement(NapeosFileBrowser, { currentPath: props.currentPath, isDialogOpen: props.isDialogOpen, extensions: extensions, elements: elements.collection.items, elementsStatus: props.elementsStatus, elementsError: props.elementsError, onAccept: props.onAccept, onCancel: props.onCancel, navigateDirectory: props.navigateDirectory })));
};
const mapStateToProps = (state, { __filebrowsernapeos, currentPath }) => {
    return {
        elements: __filebrowsernapeos.selectors.getItem(state.filebrowsernapeos, {
            relLocation: currentPath,
        }),
        elementsStatus: __filebrowsernapeos.selectors.getStatus(state.filebrowsernapeos, { relLocation: currentPath }),
        elementsError: __filebrowsernapeos.selectors.getItemError(state.filebrowsernapeos, { relLocation: currentPath }),
    };
};
const Connected = connect(mapStateToProps)(_FileBrowserNapeosFileManager);
const contextConfig = {
    __filebrowsernapeos: FileBrowserNapeosContext,
};
export const FileBrowserNapeosFileManager = withContext(contextConfig)(Connected);
//# sourceMappingURL=FileBrowserNapeosFileManager.js.map